import axios from "axios";
import getIdeasApiURL from "@src/services/ideas/getIdeasApiURL";

async function followChannel(channelName) {
  const path = `/api/ideas/follow/${channelName}`;
  const r = await axios.post(`${getIdeasApiURL()}${path}`);

  return r;
}

export default followChannel;
